import { SVGProps } from 'react';

/**
 * description: Fix for Safari SVG rendering issue
 */
export function safariSvgFix({ size }: { size: number }): SVGProps<any> {
  return {
    height: size,
    width: size,
  };
}
